type PadMarginCenterInternalProps = {
};

type PadMarginCenterPropsValues = {
  '': PadMarginCenterInternalProps;
};

const propValues: PadMarginCenterPropsValues = {
  '': {
  },
};

const getProps = (type: string): PadMarginCenterInternalProps => {
  const values: PadMarginCenterInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
